/** Static salt prepended before raw password during pre-hashing */
export const PASSWORD_PREHASH_SALT = 'pandora-password-salt:';
